export default __webpack_public_path__ + "static/media/online-support-card.58bf9c56.svg";